import { MapPin, Mail, Phone, FileText } from "lucide-react";
import BrandWordmark from "@/components/site/BrandWordmark";
import WhatsAppIcon from "@/components/site/WhatsAppIcon";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative z-10 bg-[#081936] border-t border-white/10 mt-24">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-4 gap-10">
        <div>
          <BrandWordmark variant="stacked" onDark={true} showLegal={true} />
          <p className="mt-6 text-sm text-white/70 max-w-xs leading-relaxed">
            A diversified conglomerate engineering the industrial backbone of the GCC and beyond — now with AI baked in.
          </p>
        </div>

        <div>
          <div className="font-mono text-[11px] uppercase tracking-widest text-volt mb-4">Sectors</div>
          <ul className="space-y-2 text-sm text-zinc-300">
            <li>Oil &amp; Gas</li>
            <li>Power &amp; Utilities</li>
            <li>Healthcare</li>
            <li>Automotive</li>
          </ul>
        </div>

        <div>
          <div className="font-mono text-[11px] uppercase tracking-widest text-volt mb-4">Services</div>
          <ul className="space-y-2 text-sm text-zinc-300">
            <li>Construction &amp; Industrial / EPC</li>
            <li>Information Technology</li>
            <li>Skill Training &amp; Development</li>
            <li>Recruitment Services</li>
            <li>Real Estate</li>
          </ul>
        </div>

        <div>
          <div className="font-mono text-[11px] uppercase tracking-widest text-volt mb-4">Headquarters</div>
          <ul className="space-y-3 text-sm text-zinc-300">
            <li className="flex gap-2"><MapPin size={14} className="mt-1 text-volt" /> Office 2239, Building 2504, Road 2832, Block 428 – Al Seef, Manama, Bahrain</li>
            <li className="flex gap-2"><Phone size={14} className="mt-1 text-volt" />
              <span>
                <span className="text-white/50">Office</span> +973 17567929<br/>
                <a
                  href="https://wa.me/97333340804?text=Hello%20Precision%20Contracting%20Network%2C%20I%27d%20like%20to%20discuss%20a%20project."
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp"
                  className="inline-flex items-center gap-2 hover:text-volt transition-colors"
                >
                  <span className="text-white/50">Mobile</span>
                  +973 33340804
                  <WhatsAppIcon size={12} className="text-volt" />
                </a>
              </span>
            </li>
            <li className="flex gap-2"><Mail size={14} className="mt-1 text-volt" /> <a href="mailto:slatha@srihgroup.com" className="hover:text-volt transition-colors">slatha@srihgroup.com</a></li>
            <li className="flex gap-2"><FileText size={14} className="mt-1 text-volt" /> CR 120601-01</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-5 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="font-mono text-[11px] text-zinc-500 uppercase tracking-widest">
            © {new Date().getFullYear()} Precision Contracting Network Company W.L.L · CR 120601-01 · Bahrain
          </div>
          <div className="font-mono text-[11px] text-zinc-500 uppercase tracking-widest">
            Built with PCN.ai — powered by advanced language models
          </div>
        </div>
      </div>
    </footer>
  );
}
